import I18n from "lib/i18n"
import $ from "jquery"
import Minpubsub from "minpubsub"
import debounce from "lodash/debounce"

export default class SignupProcess {
  constructor() {
    this.steps = []
    this.current_step_index = 0
    this.steps_container = $("#form-steps")

    // construction helpers
    this.build_steps()
    this.attach_subscribers()
  }

  serialise_to_json() {
    const payload = {}
    for (const step of Array.from(this.steps)) {
      const object = step.serialise_to_json()
      for (const key in object) {
        const val = object[key]
        payload[key] = val
      }
    }
    return { author: payload }
  }

  // Private Methods
  build_steps() {
    // Order here is significant
    this.steps.push(new VerifyStep(this.steps.length))
    this.steps.push(new EducationStep(this.steps.length))
    return this.steps.push(new AccountStep(this.steps.length))
  }

  has_previous_step(index) {
    return index > 0 && index < this.steps.length
  }

  previous_step(index) {
    if (this.has_previous_step(index)) {
      return this.steps[index - 1]
    }
    return false
  }

  is_last_step(index) {
    return index + 1 === this.steps.length
  }

  attach_subscribers() {
    Minpubsub.subscribe("/data-submission/from", (step_index) =>
      $.ajax({
        type: "POST",
        url: this.is_last_step(step_index) ? "/become-an-author" : "/become-an-author?dry_run=true",
        data: this.serialise_to_json(),
        dataType: "json",
        success: (data) => {
          this.steps[step_index].restore_submit_button()

          if (data.errors && !this.steps[step_index].is_valid(data.errors)) {
            return this.steps[step_index].show_errors(data.errors)
          } else if (this.is_last_step(step_index)) {
            return (document.location = data.redirect)
          }
          this.steps[step_index].hide_errors()
          return Minpubsub.publish("/step-change/to", [step_index + 1])
        },

        error: () => this.steps[step_index].restore_submit_button(),
      }),
    )

    Minpubsub.subscribe("/step-change/to", (index) => {
      if (index >= 0 && index < this.steps.length) {
        this.current_step_index = index
        const formSteps = $("#form-steps")
        formSteps.removeClass("stepped-0 stepped-1 stepped-2")
        formSteps.addClass(`stepped-${this.current_step_index}`)

        const $heading = $(`#heading-step-${this.current_step_index + 1}`).first()
        if ($heading.length > 0) {
          const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
          $heading[0].scrollIntoView({
            behavior: prefersReducedMotion ? "auto" : "smooth",
            block: "start",
          })

          const $btn = $heading.find(".step-btn")
          if ($btn.length > 0) {
            setTimeout(() => {
              $btn.focus()
            }, 50)
          }
        }
      }
    })
  }
}

class Step {
  constructor(index) {
    this.index = index
    this.form = $($("#form-steps form")[this.index])
    this.submit_button = this.form.find("input[type=submit]")
    this.nav = $($("#nav-steps li")[this.index])
    this.button = this.nav.find(".step-btn")

    this.form.submit(() => {
      this.disable_submit_button()
      Minpubsub.publish("/data-submission/from", [this.index])
      return false
    })

    this.button.on("click", (e) => {
      if (!this.button.is(":disabled")) {
        e.preventDefault()
        Minpubsub.publish("/step-change/to", [this.index])
      }
    })

    // Construction helpers
    this.attach_subscribers()
  }

  current_step() {
    return this.nav.hasClass("on")
  }

  nav_on() {
    this.nav.addClass("on").removeClass("navigable")
    this.button.attr("aria-current", "step")
    this.button.prop("disabled", false)
  }

  nav_off() {
    this.nav.removeClass("on")
    this.button.removeAttr("aria-current")
  }

  nav_clickable() {
    this.nav.addClass("navigable")
    this.button.prop("disabled", false)
  }

  nav_not_clickable() {
    this.nav.removeClass("navigable")
    // Keep current step button enabled so it stays focusable, disable upcoming unvisited steps
    if (!this.current_step()) {
      this.button.prop("disabled", true)
    }
  }

  disable_submit_button() {
    return this.submit_button.val("Processing ...").attr("disabled", "disabled")
  }

  restore_submit_button() {
    return this.submit_button.val(this.submit_button.data("original-text")).removeAttr("disabled")
  }

  // Private
  text_field(selector) {
    return this.form.find(selector).first().val()
  }

  attach_subscribers() {
    return Minpubsub.subscribe("/step-change/to", (step_index) => {
      if (step_index === this.index) {
        this.nav_on()
      } else {
        this.nav_off()
      }

      // Enable navigation button for completed steps
      if (this.index < step_index) {
        this.nav_clickable()
      } else if (this.index > step_index) {
        this.nav_not_clickable()
      }
    })
  }

  is_valid(errors) {
    let valid = true
    for (const field of Array.from(this.fields)) {
      if (errors[field] != null) {
        valid = false
      }
    }
    return valid
  }

  show_errors(errors) {
    this.hide_errors()

    const errorList = []
    const $summary = this.form.find(".error-summary")
    const $summaryList = $summary.find(".error-summary-list")

    $summaryList.empty()

    for (const field_name of this.fields) {
      if (errors[field_name]) {
        const $field = this.form.find(`[name$="[${field_name}]"]`)
        const $wrapper = $field.closest("li")
        const errorId = `${$field.attr("id")}_error`

        // Highlight field and associate aria attributes
        $wrapper.addClass("error")
        $field.attr("aria-invalid", "true")

        // Preserve existing aria-describedby IDs and append the new errorId
        const currentDescribedBy = $field.attr("aria-describedby") || ""
        const existingIds = currentDescribedBy.split(" ").filter(Boolean)

        if (!existingIds.includes(errorId)) {
          existingIds.push(errorId)
          $field.attr("aria-describedby", existingIds.join(" "))
        }

        // Insert inline error with matching ID and alert role
        $wrapper.append(
          `<p id="${errorId}" class="inline-errors" role="alert">${errors[field_name]}</p>`,
        )

        // Build error summary link
        const $errorLink = $(`<a href="#${$field.attr("id")}">${errors[field_name]}</a>`)

        $errorLink.on("click", (e) => {
          e.preventDefault()
          $field.focus()
        })

        $summaryList.append($("<li></li>").append($errorLink))
        errorList.push(field_name)
      }
    }

    // Shift focus to summary box so screen readers announce errors immediately
    if (errorList.length > 0 && $summary.length > 0) {
      $summary.removeClass("hidden").focus()
    }
  }

  hide_errors() {
    this.form.find(".error-summary").addClass("hidden")
    this.form.find("li.error").removeClass("error")
    this.form.find("input, select, textarea").removeAttr("aria-invalid")

    // Remove only the _error tokens from aria-describedby
    this.form.find("input, select, textarea").each((_, input) => {
      const $input = $(input)
      $input.removeAttr("aria-invalid")

      const currentDescribedBy = $input.attr("aria-describedby") || ""
      const remainingIds = currentDescribedBy
        .split(" ")
        .filter((id) => id && !id.endsWith("_error"))
        .join(" ")

      if (remainingIds.length > 0) {
        $input.attr("aria-describedby", remainingIds)
      } else {
        $input.removeAttr("aria-describedby")
      }
    })

    this.form.find("p.inline-errors").remove()
  }
}

class VerifyStep extends Step {
  static initClass() {
    this.prototype.fields = ["email", "institution_name", "byline_title", "full_name"]
  }
  constructor(index) {
    super(index)
    this.autodetectRequest = null

    // Stamp ID on Formtastic's hint paragraph on load,
    // newer versions of formtastic have better ways to do this
    $("#registration_form_email_input .inline-hints").attr("id", "registration_form_email_hint")
    $("#registration_form_full_name_input .inline-hints").attr(
      "id",
      "registration_form_full_name_hint",
    )
    $("#registration_form_byline_title_input .inline-hints").attr(
      "id",
      "registration_form_byline_hint",
    )

    $("#registration_form_email").on(
      "change keyup input",
      debounce(this.autodetectInstitution.bind(this), 250),
    )
  }

  serialise_to_json() {
    return {
      email: this.text_field("#registration_form_email"),
      institution_name: this.text_field("#registration_form_institution_name"),
      full_name: this.text_field("#registration_form_full_name"),
      byline_title: this.text_field("#registration_form_byline_title"),
    }
  }

  getEmailFieldDomain() {
    const email = $("#registration_form_email").val().toLowerCase()
    const parts = email.split("@")
    const domain = parts[parts.length - 1]

    return domain
  }

  // Private
  autodetectInstitution() {
    if (this.autodetectRequest !== null) {
      this.autodetectRequest.abort()
    }

    const emailInput = $("#registration_form_email")
    const domain = this.getEmailFieldDomain()
    const institutionField = $("#registration_form_institution_name_input")

    const institutionDetails = $(".institution-details")

    const autosetInstitution = function (name, logoUrl) {
      institutionField.find(".inline-errors").hide()
      institutionField.find("input").val(name)
      institutionDetails.html(
        `<img src='${logoUrl}' alt="${I18n.t("author_registration.matched")}" class="py-2.5 max-w-30 block"><p>${name}</p>`,
      )
      emailInput.removeAttr("aria-invalid")
      emailInput.attr("aria-describedby", "institution-status registration_form_email_hint")
    }

    const cleanInstitution = function () {
      institutionField.find(".inline-errors").show()
      institutionField.find("input").val("")
      institutionDetails.html(
        `<span class="sm:max-w-2xl">${I18n.t(
          "author_registration.error.couldnt_match_domain_to_institution",
          {
            email: I18n.t("common.region_support_email_address"),
          },
        )}</span>`,
      )
      emailInput.attr("aria-invalid", "true")
      emailInput.attr("aria-describedby", "registration_form_email_hint")
    }

    const updateInstitution = function (data) {
      if (data.query !== this.getEmailFieldDomain()) {
        return
      }

      if (data.results && data.results.length > 0) {
        autosetInstitution(data.results[0].label, data.results[0].institution.logo_url)
      } else {
        cleanInstitution()
      }
    }

    this.autodetectRequest = $.ajax({
      url: "/institutions/matching",
      data: { domain },
      method: "GET",
      success: updateInstitution.bind(this),
    })
  }
}
VerifyStep.initClass()

class EducationStep extends Step {
  static initClass() {
    this.prototype.fields = [
      "education_year",
      "education_award",
      "education_institution",
      "summary",
    ]
  }

  serialise_to_json() {
    return {
      education_year: this.text_field("#registration_form_education_year"),
      education_award: this.text_field("#registration_form_education_award"),
      education_institution: this.text_field("#registration_form_education_institution"),
      summary: this.text_field("#registration_form_summary"),
    }
  }
}
EducationStep.initClass()

class AccountStep extends Step {
  static initClass() {
    this.prototype.fields = ["password", "password_confirmation", "secondary_email"]
  }

  serialise_to_json() {
    return {
      password: this.text_field("#registration_form_password"),
      password_confirmation: this.text_field("#registration_form_password_confirmation"),
      secondary_email: this.text_field("#registration_form_secondary_email"),
    }
  }
}
AccountStep.initClass()
